import React from 'react';
import s from '../menu/Menu.module.css';
import Item from '../menu/Item';
import Nav from '../Nav/Nav';
import burger_img from '../../img/Mak.png'
import snack_img from '../../img/snack.jpg'
import hach_img from '../../img/hach.png'
import saltyPastries_img from '../../img/saltyvipechka.webp'

const MakMenu = (props) => {
    return (
        <div className={s.menu}>
            <Nav link='/' name='Мак меню'/>
            <main className={s.main}>
                <Item link='/burgers' name='Бургери' img={burger_img}/>
                <Item link='/snaks' name='Снеки' img={snack_img}/>
                <Item link='/hachapury' name='Хачапурі' img={hach_img}/>
                <Item link='/saltyPastries' name='Солона випічка' img={saltyPastries_img}/>
            </main>
        </div>
    )
}

export default MakMenu;